import { render, staticRenderFns } from "./betteruptimeTicketModal.vue?vue&type=template&id=b200c4c8&scoped=true"
import script from "./betteruptimeTicketModal.vue?vue&type=script&lang=js"
export * from "./betteruptimeTicketModal.vue?vue&type=script&lang=js"
import style0 from "./betteruptimeTicketModal.vue?vue&type=style&index=0&id=b200c4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b200c4c8",
  null
  
)

export default component.exports